define('views/modules/supervisor/supervisor-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // services
    'services/i18n',
    // views
    'views/modules/supervisor/supervisor-icon',
    // templates
    'text!templates/modules/supervisor/supervisor-list-item.html',
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // services
    i18n,
    // views
    VSupervisorIcon,
    // templates
    TSupervisorListItem
) {

    var VSupervisorListItem = Backbone.Epoxy.View.extend({
        className: 'coach',
        template: TSupervisorListItem,

        regions: {
            icon: '.supervisor-icon',
        },

        events: {
            "click": "onClick"
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.view = {
                icon: new VSupervisorIcon()
            };
        },

        render: function() {
            var opt = this.options;
            this.$el.empty().append(
              Mustache.render(
                this.template, Mustache.getContext({
                  supervisorName: this.model.get('firstname'),
                  welcomeTitle: function() {
                    return function(text, render) {
                      var translated = i18n.t(text, { "supervisorName": this.supervisorName });
                      return render(translated);
                    };
                  }
                })
              )
            );

            this.generateZones()
                .applyBindings();

            this.assign(this.view.icon, this.zone.$icon);

            return this;
        },

        onClick: function(e) {
            e.preventDefault();

            Backbone.history.navigate(
                Mustache.render('#/' + this.options.url, { groupId: this.options.group.id, userId: this.model.id, })
            );
        }

    });

    return VSupervisorListItem;

});

